// extracted by mini-css-extract-plugin
module.exports = {"loginContainer":"LoginTemplate_loginContainer__1mixV","contents":"LoginTemplate_contents__1-j4s","rightContents":"LoginTemplate_rightContents__1gOaF"};